import { Outlet, Link, useLocation } from "react-router-dom";
import { LayoutGrid, FileText, BookOpen, Sparkles, Award } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";

const NavItem = ({ to, icon: Icon, label, active }) => (
    <Link
        to={to}
        data-testid={`nav-${label.toLowerCase()}`}
        className={`flex items-center gap-3 px-4 py-2.5 text-sm font-medium border-l-2 transition-colors ${
            active
                ? "border-accent text-ink bg-white"
                : "border-transparent text-ink-soft hover:text-ink hover:bg-white"
        }`}
    >
        <Icon className="w-4 h-4" strokeWidth={1.6} />
        {label}
    </Link>
);

export default function Layout() {
    const loc = useLocation();
    const isProjects = loc.pathname === "/" || loc.pathname.startsWith("/chantiers");
    const isMarket = loc.pathname.startsWith("/etude-de-marche");

    return (
        <div className="min-h-screen flex">
            {/* Sidebar */}
            <aside
                data-testid="sidebar"
                className="w-64 shrink-0 bg-[#FAFAFA] border-r border-border flex flex-col"
            >
                <Link
                    to="/"
                    className="px-6 py-6 border-b border-border block"
                    data-testid="brand-link"
                >
                    <BrandLogo size="md" />
                </Link>
                <nav className="py-3 flex-1">
                    <NavItem
                        to="/"
                        icon={LayoutGrid}
                        label="Chantiers"
                        active={isProjects}
                    />
                    <NavItem
                        to="/etude-de-marche"
                        icon={Award}
                        label="Étude de marché"
                        active={isMarket}
                    />
                    <div className="px-4 py-2.5 text-xs uppercase tracking-[0.12em] text-ink-soft/70 mt-4 mb-1">
                        Outils
                    </div>
                    <div className="flex items-center gap-3 px-4 py-2 text-sm text-ink-soft cursor-default">
                        <FileText className="w-4 h-4" strokeWidth={1.6} />
                        Trames CCTP
                    </div>
                    <div className="flex items-center gap-3 px-4 py-2 text-sm text-ink-soft cursor-default">
                        <Sparkles className="w-4 h-4" strokeWidth={1.6} />
                        Analyse IA
                    </div>
                    <div className="flex items-center gap-3 px-4 py-2 text-sm text-ink-soft cursor-default">
                        <BookOpen className="w-4 h-4" strokeWidth={1.6} />
                        Aide
                    </div>
                </nav>
                <div className="p-4 border-t border-border">
                    <div className="text-[10px] uppercase tracking-[0.18em] text-ink-soft">
                        Compte
                    </div>
                    <div className="text-sm font-medium mt-1">AB Promotion</div>
                    <div className="text-xs text-ink-soft">Espace promoteur</div>
                </div>
            </aside>

            {/* Main */}
            <main className="flex-1 min-w-0">
                <Outlet />
            </main>
        </div>
    );
}
